<nav
  class="mobile-bottom-bar"
  aria-label="Atalhos principais"
  data-testid="mobile-bottom-bar">
  @for (item of items(); track item.id) {
    <a
      class="mobile-bottom-bar__item"
      [class.mobile-bottom-bar__item--active]="item.domainId === activeDomainId()"
      [attr.data-testid]="'mobile-bottom-bar-' + item.id"
      [attr.data-tour]="tourAnchor(item.domainId)"
      [attr.aria-current]="item.domainId === activeDomainId() ? 'page' : null"
      [routerLink]="item.route">
      <lucide-icon
        [name]="item.icon"
        [size]="20"
        [strokeWidth]="1.75"
        aria-hidden="true" />
      <span class="mobile-bottom-bar__label">{{ item.label }}</span>
    </a>
  }

  <button
    type="button"
    class="mobile-bottom-bar__item"
    data-testid="mobile-bottom-bar-menu"
    aria-haspopup="dialog"
    aria-controls="mobile-navigation-drawer"
    [attr.aria-expanded]="menuOpen()"
    (click)="menuToggle.emit()">
    <lucide-icon
      name="menu"
      [size]="20"
      [strokeWidth]="1.75"
      aria-hidden="true" />
    <span class="mobile-bottom-bar__label">Menu</span>
  </button>
</nav>
